import Button from "@scripts/react/components/Button";
import { TooltipContainer } from "@scripts/react/components/Tooltip";

interface AddFilesButtonProps {
    onClick: () => void;
    disabled?: boolean;
    hasVideo?: boolean;
}

export function AddFilesButton({
    onClick,
    disabled = false,
    hasVideo = false
}: AddFilesButtonProps) {
    const button = (
        <Button
            type="secondary"
            size="xlarge"
            shape="square"
            onClick={onClick}
            disabled={disabled}
            aria-label="Add files"
            title={disabled ? undefined : "Add files"}
            className="addFilesButton group"
        >
            <i className="far fa-plus transition-transform duration-200 group-hover:scale-125" />
        </Button>
    );

    if (disabled) {
        return (
            <TooltipContainer
                type="titleOnly"
                placement="top"
                interactive={true}
                title={
                    <span>
                        <strong>
                            {hasVideo
                                ? "You only need 1 video to build a model. "
                                : "You only need 10 images to build a model. "}
                        </strong>
                        <br></br> To label a large amount of data, use our{" "}
                        <a
                            href="https://app.roboflow.com"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="text-purboflow-300"
                        >
                            core platform
                        </a>
                        .
                    </span>
                }
                customButton={
                    // Wrapper div needed because disabled buttons don't trigger hover events
                    <div className="inline-block">{button}</div>
                }
            />
        );
    }

    return button;
}
